let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("8lm5x")]).then(() => parcelRequire('ftqx5'));